module.exports = __webpack_public_path__ + "img/day2.028dc233.jpeg";